import React from "react";
import { Document, Image, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { commonStyles } from "../../Services/ReactPDFService.jsx";

// Photo Cover Letter Template - Enhanced Professional Photo-Focused Design
const styles = StyleSheet.create({
  ...commonStyles,
  page: {
    ...commonStyles.page,
    fontFamily: "Roboto",
    backgroundColor: "#ffffff",
    padding: 0,
  },
  // Gradient background header
  topBar: {
    backgroundColor: "#1e3a8a",
    backgroundImage: "linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)",
    padding: "50 60",
    position: "relative",
  },
  // Decorative circle
  decorativeCircle: {
    position: "absolute",
    right: -40,
    top: -40,
    width: 180,
    height: 180,
    backgroundColor: "#3b82f6",
    opacity: 0.2,
    borderRadius: 90,
  },
  headerContainer: {
    flexDirection: "row",
    alignItems: "center",
    position: "relative",
    zIndex: 1,
  },
  photoContainer: {
    width: 100,
    height: 100,
    borderRadius: 50,
    overflow: "hidden",
    marginRight: 30,
    borderWidth: 5,
    borderColor: "#ffffff",
    backgroundColor: "#dbeafe",
    shadowColor: "#000",
    shadowOpacity: 0.2,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 4 },
  },
  photo: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  placeholder: {
    width: "100%",
    height: "100%",
    backgroundColor: "#dbeafe",
    justifyContent: "center",
    alignItems: "center",
  },
  placeholderText: {
    fontSize: 36,
    color: "#2563eb",
    fontWeight: 700,
  },
  headerInfo: {
    flex: 1,
  },
  name: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 18,
    color: "#ffffff",
    letterSpacing: 0.5,
  },
  contactRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 3,
  },
  contactInfo: {
    fontSize: 11,
    color: "#e0e7ff",
    letterSpacing: 0.3,
  },
  mainContent: {
    padding: "45 60",
  },
  bodyText: {
    fontSize: 11,
    lineHeight: 1.8,
    color: "#334155",
    marginBottom: 12,
    textAlign: "justify",
  },
});

const PhotoCoverLetter = ({ resumeData, coverLetterData }) => {
  // Check multiple locations for profile photo URL
  const profilePhoto = resumeData?.profilePhotoUrl || resumeData?.profilePhoto?.url || coverLetterData?.profilePhoto?.url || null;
  const { header, generatedContent } = coverLetterData || {};
  const { name, email, phone, location } = header || {};

  // Get initials for placeholder
  const initials = (name || "Your Name")
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .substring(0, 2);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Gradient Header with Photo */}
        <View style={styles.topBar}>
          <View style={styles.decorativeCircle} />
          <View style={styles.headerContainer}>
            {/* Profile Photo or Initials */}
            <View style={styles.photoContainer}>
              {profilePhoto ? (
                <Image src={profilePhoto} style={styles.photo} />
              ) : (
                <View style={styles.placeholder}>
                  <Text style={styles.placeholderText}>{initials}</Text>
                </View>
              )}
            </View>

            {/* Header Info */}
            <View style={styles.headerInfo}>
              <Text style={styles.name}>{name || "[Name]"}</Text>

              <View style={styles.contactRow}>
                <Text style={styles.contactInfo}>{email || "[Email]"}</Text>
              </View>

              <View style={styles.contactRow}>
                <Text style={styles.contactInfo}>{phone || "[Phone]"}</Text>
              </View>

              <View style={styles.contactRow}>
                <Text style={styles.contactInfo}>{location || "[Location]"}</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Main Content */}
        <View style={styles.mainContent}>
          <Text style={styles.bodyText}>{generatedContent || "No content generated yet."}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default PhotoCoverLetter;
